<div class="bg-col-w b-a b-col-5"
     style="border-radius: 12px;">
    <button type="button"
            class="flex flex-justify-between flex-middle col-1 w-12 p-a"
            (click)="toggle()">
        <span class="p2 _title left">
            {{expandableTitle}}
        </span>
        <span class="pos-relative">
            <i class="icon-minus flex"></i>
            <i class="icon-plus _icon-plus fill flex"
               [ngClass]="{'_icon-plus--active' : !toggleState}"></i>
        </span>
    </button>

    <div class="_animate"
         [hideUp]="toggleState">
        <div class="p-a p-t-0">
            <ng-content></ng-content>
        </div>
    </div>
</div>